import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('student-forms', {
  key: 'student-forms',
  label: 'Student Forms',
  getSteps: () => [
    step({
      target: '#tour-student-forms-grid',
      title: 'Forms',
      content:
        'Forms made available to you — surveys, declarations, applications. Each card shows the title, an optional fee, and a button to fill it out.',
      placement: 'top',
    }),
  ],
});

registerTourPage('student-form-fill', {
  key: 'student-form-fill',
  label: 'Fill Form',
  getSteps: () => [
    introStep({
      title: 'Fill Out the Form',
      content:
        'Answer the questions in order. Required fields are marked, and validation runs when you submit. If the form has a fee, you\'ll be taken to payment after a successful submission.',
    }),
  ],
});

registerTourPage('student-tickets', {
  key: 'student-tickets',
  label: 'Support Tickets',
  getSteps: () => [
    step({
      target: '#tour-student-tickets-header',
      title: 'Need Help?',
      content:
        'Open a support ticket and a staff member will get back to you. Click "New Ticket" to start one — pick a category, describe the issue, and optionally attach files.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-student-tickets-controls',
      title: 'Filter & Search',
      content:
        'Switch tabs to filter by status, or type in the search box to find a specific ticket by subject.',
      placement: 'bottom',
    }),
  ],
});

registerTourPage('student-ticket-detail', {
  key: 'student-ticket-detail',
  label: 'Ticket Detail',
  getSteps: () => [
    introStep({
      title: 'Your Ticket',
      content:
        'The full thread — your messages and the staff replies. Type a follow-up at the bottom to keep the conversation going.',
    }),
  ],
});

registerTourPage('student-message', {
  key: 'student-message',
  label: 'Messages',
  getSteps: () => [
    introStep({
      title: 'Messages',
      content:
        'Compose a new message in "Create Message", or browse what you\'ve sent and received using the other tabs.',
    }),
  ],
});

registerTourPage('student-eclass', {
  key: 'student-eclass',
  label: 'E-Class',
  getSteps: () => [
    introStep({
      title: 'E-Class Resources',
      content:
        'Notes, slides, recordings, and links staff have shared, organised by subject.',
    }),
  ],
});

registerTourPage('student-settings', {
  key: 'student-settings',
  label: 'Settings',
  getSteps: () => [
    introStep({
      title: 'Account Settings',
      content:
        '"Reset Password" lets you change your password. "Update Profile" is where you keep your contact details current.',
    }),
  ],
});
